import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, UrlSegment } from "@angular/router";
import { isEqualWith } from "lodash-es";


export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.url.length <= 1 && isEqualWith(future.url, curr.url, (a: UrlSegment, b: UrlSegment) => a.path === b.path)) {
      return super.shouldReuseRoute(future, curr);
    }
    return false;
  }
}
